var render = function render(){var _vm=this,_c=_vm._self._c;return _c('escalation-status',_vm._g(_vm._b({ref:"escalationStatus",attrs:{"header-text":_vm.headerText,"status-subtexts":_vm.statusSubtexts,"value":_vm.value}},'escalation-status',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }